module.exports = __webpack_public_path__ + "img/C540.182177b2.jpg";